<template>
  <header class="pl-topbar pl-desktop-only">
    <div class="pl-topbar__inner">
      <router-link to="/summary" aria-label="Peakslog — pulpit"><PlLogo size="md" /></router-link>

      <nav class="pl-topbar__nav" aria-label="Nawigacja aplikacji">
        <router-link
          to="/summary"
          class="pl-topbar__link"
          :class="{ 'pl-topbar__link--active': section === 'dashboard' }"
        >Pulpit</router-link>
        <router-link
          to="/map"
          class="pl-topbar__link"
          :class="{ 'pl-topbar__link--active': section === 'map' }"
        >Mapa</router-link>
        <router-link
          to="/challenges"
          class="pl-topbar__link"
          :class="{ 'pl-topbar__link--active': section === 'badges' }"
        >Odznaczenia</router-link>
      </nav>

      <div class="pl-topbar__actions">
        <router-link to="/share" class="pl-cta pl-cta--compact">
          <PlIcon name="share" :size="16" />
          Udostępnij
        </router-link>
        <PlAccountMenu />
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PlAccountMenu from './PlAccountMenu.vue'
import PlIcon from './PlIcon.vue'
import PlLogo from './PlLogo.vue'

// Górny pasek ekranów aplikacji na desktopie (na telefonie każdy ekran ma
// własny nagłówek z designu mobilnego).
const route = useRoute()

// Legenda i karty wyzwań należą do sekcji "Odznaczenia"
const section = computed(() => {
  // Lista wszystkich szczytów jest rozwinięciem sekcji "Ostatnie zdobycze" pulpitu
  if (route.path === '/summary' || route.path === '/peaks') return 'dashboard'
  if (route.path === '/map') return 'map'
  if (route.path.startsWith('/challenges') || route.name === 'ShareChallenge') return 'badges'
  return null
})
</script>

<style scoped>
.pl-topbar {
  position: sticky;
  top: 0;
  z-index: 30;
  height: var(--pl-space-topbar-height);
  border-bottom: 1px solid var(--pl-color-border-divider);
  background: var(--pl-color-bg-app);
}

.pl-topbar__inner {
  display: flex;
  align-items: center;
  gap: 48px;
  height: 100%;
  max-width: var(--pl-space-content-max);
  margin: 0 auto;
  padding: 0 var(--pl-space-desktop-x);
}

.pl-topbar__nav {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-grow: 1;
}

.pl-topbar__link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  border-bottom: 2px solid transparent;
  font: var(--pl-type-landing-nav);
  color: var(--pl-color-text-secondary);
}

.pl-topbar__link:hover {
  color: var(--pl-color-text-primary);
}

.pl-topbar__link--active {
  border-bottom-color: var(--pl-color-accent-clay);
  font: var(--pl-type-landing-nav-strong);
  color: var(--pl-color-text-primary);
}

.pl-topbar__actions {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
